import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';
import { LeadForQueueSchema } from './shared/leadForQueue';

type Arguments = Record<string, never>;

export const schemaLoanRequestResolver_GetLeadsWithoutAttribution = z.array(LeadForQueueSchema);

export type SchemaLoanRequestResolver_GetLeadsWithoutAttribution = z.infer<
    typeof schemaLoanRequestResolver_GetLeadsWithoutAttribution
>;

export type LoanRequestResolver_GetLeadsWithoutAttribution = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetLeadsWithoutAttribution
>;
